import { apiRequest, getResource } from "../api/http";

// Maintenance of the whole database: system and super admins only. All of
// them reject on failure (the API message is in `error.response.data.message`).
const BASE = "/api/admin/maintenance";
const options = { rethrow: true };

/** Tasks with their last preview, last run and the run in progress. */
export function getMaintenanceTasks() {
  return getResource(`${BASE}/tasks`, { ...options, select: (data) => data.tasks });
}

/** Starts a preview (nothing is changed). Resolves with the run. */
export function previewMaintenanceTask(key) {
  return apiRequest("post", `${BASE}/tasks/${key}/preview`, { ...options, select: (data) => data.run });
}

/** Starts the task for real (the API asks for the key as confirmation). */
export function runMaintenanceTask(key) {
  return apiRequest("post", `${BASE}/tasks/${key}/run`, {
    ...options,
    data: { confirm: key },
    select: (data) => data.run,
  });
}

export function getMaintenanceRun(id) {
  return getResource(`${BASE}/runs/${id}`, { ...options, select: (data) => data.run });
}

export function getMaintenanceRuns(page = 1) {
  return getResource(`${BASE}/runs?page=${page}`, options);
}

/** Site maintenance mode (afomedia.com): { enabled, message, until, since, by, previewUrl, defaultMessage }. */
export function getSiteMaintenance() {
  return getResource("/api/admin/site-status", options);
}

/** { enabled?, message?, until? }: a new team link is created each time the mode is switched on. */
export function updateSiteMaintenance(data) {
  return apiRequest("put", "/api/admin/site-status", { ...options, data });
}

/** Affluence mode (manual only): { enabled, message, since, by, defaultMessage, maxInflight }. */
export function getTrafficMode() {
  return getResource("/api/admin/site-status/traffic", options);
}

export function updateTrafficMode(data) {
  return apiRequest("put", "/api/admin/site-status/traffic", { ...options, data });
}
